module.exports = __webpack_public_path__ + "img/guide2.e633a808.jpeg";